module.exports = __webpack_public_path__ + "static/media/star.69c71386.png";